import { SxProps, Theme } from '@mui/material';

export const AccountSummaryTitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-md)',
	fontWeight: 800,
	marginBottom: '20px',
	textTransform: 'uppercase',
};

export const AccountSummaryLinkButtonSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-default)',
	color: theme.palette.primary.main,
	alignSelf: { xs: 'center', md: 'flex-start' },
	marginTop: '20px !important',
	'&:hover': {
		textDecoration: 'underline',
	},
});

export const AccountSummaryOrdersLinkButtonSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-default)',
	color: theme.palette.primary.main,
	alignSelf: { xs: 'center', md: 'flex-start' },
	marginTop: '20px !important',
	'&:hover': {
		textDecoration: 'underline',
	},
});
